export default function SessionTimeline({
  messages,
  loading,
  error,
  hasMoreBefore,
  onLoadOlder,
}) {
  return (
    <>
      <div className="cs-panel__head">
        <span>對話</span>
        {hasMoreBefore ? (
          <button type="button" className="btn btn-secondary btn-sm" onClick={onLoadOlder}>
            載入更早
          </button>
        ) : null}
      </div>
      {error ? <div className="cs-error">{error}</div> : null}
      <div className="cs-timeline">
        {loading && !(messages || []).length ? <div className="cs-hint">載入訊息…</div> : null}
        {(messages || []).map((msg) => {
          const isSystem = msg.messageType === 'SYSTEM' || msg.senderType === 'SYSTEM';
          const isAgent = msg.senderType === 'ADMIN_AGENT';
          const cls = isSystem ? 'cs-msg cs-msg--system' : isAgent ? 'cs-msg cs-msg--agent' : 'cs-msg';
          return (
            <div key={msg.serverMessageId || `${msg.seq}`} className={cls}>
              {!isSystem ? (
                <div className="cs-msg__meta">
                  {isAgent ? '客服' : '會員'}
                  {msg.seq != null ? ` · #${msg.seq}` : ''}
                </div>
              ) : null}
              <div>{msg.text || msg.systemCode || '（無內容）'}</div>
            </div>
          );
        })}
        {!loading && !(messages || []).length ? (
          <div className="cs-empty">尚無訊息，選取 Session 後顯示時間軸</div>
        ) : null}
      </div>
    </>
  );
}
